import SubNavigationMobile from "@/components/elements/SubNavigationMobile";
import UserProfileForm from "@/components/settings/UserProfileForm";
import useAuth from "@/hooks/auth";
import { useIsMobile } from "@/hooks/useIsMobile";
import AccountLayout from "@/layouts/AccountLayout";
import { useRouter } from "next/router";

export default function Profile() {
  const { user } = useAuth({ middleware: "auth" });
  const router = useRouter();
  const { redirect_to } = router.query;
  const isMobile = useIsMobile();
  return (
    <AccountLayout title={"Profile | Lucidity Insights"}>
      <div className='container'>
        {isMobile && <SubNavigationMobile label='User Profile' />}
        <div className='lg:rounded-md p-4 lg:p-6 border-y border-x border-y-white/10 border-x-white/[0.03] bg-gradient-to-t from-white/[0.05] to-white/[0.07] shadow-md'>
          <p className='text-2xl font-semibold'>Profile</p>
          <p className='pb-5 mt-1.5 text-sm border-b text-white/40'>
            Manage your Lucidity Insights profile.
          </p>
          <UserProfileForm redirect_to={redirect_to} />
        </div>
      </div>
    </AccountLayout>
  );
}
